module.exports = __webpack_public_path__ + "7d80af036bd7b3f44c3c890baaea17da.png";